var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col logo-header" },
        [
          _c("router-link", { attrs: { to: "/" } }, [
            _c("img", {
              attrs: {
                src: require("../assets/images/logo.png"),
                width: "111px"
              }
            })
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("recover.title")))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-content-center" }, [
      _c(
        "div",
        { staticClass: "col-8 col-sm-4" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "o-label",
              attrs: {
                id: "email-form-group",
                label: "Email",
                "label-for": "email-input"
              }
            },
            [
              _c("b-form-input", {
                staticClass: "o-form",
                attrs: {
                  id: "email-input",
                  type: "text",
                  required: "",
                  placeholder: "Email"
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-content-center" }, [
      _c(
        "div",
        { staticClass: "col col-8 col-sm-4" },
        [
          _c(
            "b-button",
            {
              staticClass: "o-button",
              on: { click: _vm.recoverPasswordByEmail }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("recover.resetPasswordButton")) +
                  "\n            "
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row justify-content-center signup-text" }, [
      _c("div", { staticClass: "col col-8 col-sm-4 links" }, [
        _c(
          "div",
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("signup.alreadyRegistered")) +
                "\n                "
            ),
            _c("router-link", { attrs: { to: "/login" } }, [
              _vm._v(_vm._s(_vm.$t("signup.loginAction")))
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "language-selection" }, [
          _c("h6", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    _vm.switchLang("de")
                  }
                }
              },
              [_vm._v("Deutsch")]
            ),
            _vm._v(" |\n                    "),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    _vm.switchLang("en")
                  }
                }
              },
              [_vm._v("English")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c2a38ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c2a38ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecoverPasswordComponent.vue
// module id = null
// module chunks = 